import { ATextInteractive } from '../../atoms/ATextInteractive/index';
import { ATextInteractiveProps, ATextInteractiveSize } from '../../atoms/ATextInteractive/ATextInteractive.types';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import * as Styled from './MBreadcrumb.styles';
import { MBreadcrumbProps } from './MBreadcrumb.types';

const TEST_ID = 'mi-web-ui-kit-MBreadcrumb';
const COMPONENT_NAME = 'm-web-ui-kit-MBreadcrumb';

function MBreadcrumb({ aTextInteractive, ...rest }: MBreadcrumbProps) {
  const isActive = Boolean(aTextInteractive?.href?.trim().length);

  const _aTextInteractive: Partial<ATextInteractiveProps> = {
    ...aTextInteractive,
    size: ATextInteractiveSize.XS,
  };

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} {...rest}>
      <ATextInteractive {...(_aTextInteractive as ATextInteractiveProps)} />
      {isActive && <Styled.AIcon icon="icon-arrow-right" size={AIconSize.S} />}
    </Styled.Wrapper>
  );
}

export { MBreadcrumb, TEST_ID as M_BREADCRUMB_TEST_ID };
